import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AppConfig } from './app-config.model';
import { APP_VERSION } from './app-version';

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private readonly http = inject(HttpClient);
  private readonly configSignal = signal<AppConfig | null>(null);

  readonly settings = this.configSignal.asReadonly();

  async loadConfig(): Promise<void> {
    try {
      const config = await lastValueFrom(
        this.http.get<Omit<AppConfig, 'version'>>(environment.configFile),
      );
      this.configSignal.set({ ...config, version: APP_VERSION });
      console.info(`[Config] Ambiente "${environment.name}" carregado de ${environment.configFile}`);
    } catch (error) {
      console.error(`Falha ao carregar a configuração de ${environment.configFile}`, error);
      throw error; // bloqueia o bootstrap da aplicação
    }
  }
}
